function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useState, useEffect } from "react";
import { ControlledInput } from "../../../styled/input/ControlledInput";
import { UnstyledTableFilterWrapper } from "../../../unstyled/table/wrapper/UnstyledTableFilterWrapper";
import "./tableFilterWrapper.css";

/*
    Wraps the Table to add filtering

    dependencies in children prop
        (optional)  TableBodyNoDataWrapper  It is used to show the noFilterResultsMessage

    props
        (array, required)      columns                          This component uses the following keys from each column object (if they are declared)
                                                                    - (boolean, optional)  filterEnabled      When true, the column can be filtered and the filter input is shown
                                                                    - (function, optional) filterValueFunc    A function that returns the value to filter by
                                                                        - Example where the cell (row dataKey value) is an object: (cell, row) => cell.name
                                                                    - (string, optional)   filterPlaceholder  The filter input placeholder
        (jsx, optional)        noDataMessage                    See TableBodyNoDataWrapper
                                                                    - Overriden by noFilterResultsMessage when there are no filter results
        (jsx, optional)        noFilterResultsMessage           The content to show when there are no filter results
        (object, optional)     defaultActiveFilters             The initial filters to be applied to the table
                                                                    - Example where the dataKey is "name" = {
                                                                        name: {
                                                                            query: "something"
                                                                        }
                                                                    }
        (component, optional)  FilterControlledInputComponent   The controlled input component to use for each column filter input
*/

const TableFilterWrapper = ({
  classPrepend = "styled",
  columns = [],
  rows = [],
  noDataMessage,
  noFilterResultsMessage = "No results found, please refine your filters",
  defaultActiveFilters = {},
  FilterControlledInputComponent = ControlledInput,
  children,
  ...rest
}) => {
  return /*#__PURE__*/React.createElement(UnstyledTableFilterWrapper, _extends({
    classPrepend: classPrepend,
    columns: columns,
    rows: rows,
    noDataMessage: noDataMessage,
    noFilterResultsMessage: noFilterResultsMessage,
    defaultActiveFilters: defaultActiveFilters,
    FilterControlledInputComponent: FilterControlledInputComponent,
    children: children
  }, rest));
};
export { TableFilterWrapper };